module.exports = __webpack_public_path__ + "html/delivery-form.template.html";